import React from "react";
import { Wrapper, Wrap, StyledHeader } from "./styles";
import Header from "../../../share/organisms/headers/features-header";
import Container from "../../../share/atoms/container/index";
import Footer from "../../LandingPage/Footer/index";
import { useScrollTo } from "share/hooks/useScrollTo";
import TermsHeader from "share/organisms/headers/terms-header";

const TermsAndConditionsPage = (props) => {
  useScrollTo(0, 0);
  return (
    <div style={{ backgroundColor: "#f9f9ff" }}>
      {!props.isHome && <TermsHeader />}
      <Wrap style={{ border: "1px solid transparent" }}>
        <Container>
          <Wrapper>
            <StyledHeader>Terms & Conditions</StyledHeader>
            <iframe
              width="100%"
              style={{ height: "100vh", border: "none" }}
              src="https://neap-sandbox.s3.ap-south-1.amazonaws.com/FE-assets/terms-and-conditions-neap.html"
              title="terms"
            />
          </Wrapper>
        </Container>
      </Wrap>
    </div>
  );
};

export default TermsAndConditionsPage;
